import RichTextEditor from 'react-rte'

import { msg } from '..'
import * as Util from '../Util'

export function required(value: any) {
  if (Util.isEmpty(value) || !/\S/.test(value)) {
    return msg('required', value)
  }
}

export function requiredRichText(value: any) {
  const richTextValue = RichTextEditor.createValueFromString(value, 'html')
  let texto = ''
  const textBlocks = JSON.parse(richTextValue.toString('raw')).blocks
  textBlocks.forEach((e) => (texto += e.text?.toString()))
  return required(value) || required(texto)
}
